// src/components/LoadingSpinner/LoadingSpinner.js
import React from 'react';
// import './LoadingSpinner.css'; // Opsional: Buat file CSS untuk styling spinner

const LoadingSpinner = () => {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh', // Memastikan spinner di tengah layar
      fontSize: '20px',
      color: '#333',
      background: '#f8f8f8',
      flexDirection: 'column',
      gap: '10px'
    }}>
      <div className="spinner"></div> {/* Ini bisa diganti dengan CSS spinner yang lebih kompleks */}
      Memuat Konten...
    </div>
  );
};

export default LoadingSpinner;

/* Opsional: Contoh Styling Sederhana untuk LoadingSpinner.css */
/*
.spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border-left-color: #09f;
  animation: spin 1s ease infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
*/